<template>
  <section id="planos">
      <div class="container">
        <h4 class="display-3">
          CONHEÇA OS PLANOS
        </h4>
        <div class="row d-flex align-content-stretch flex-wrap">
            <div class="col-md-4 col-12"
              v-for="plano in planos" :key="plano._id">
              <div class="plan-card">
                  <div class="row">
                      <div class="col">
                          <p class="title-plan">
                              {{plano.name}}
                          </p>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col">
                          <div class="price">
                              <p><span>R$</span> {{plano.price | money(money)}}</p>
                              <span>/ Mês</span>
                              <p style="color: green; font-size: 1.4rem" v-if="plano.name === 'Seguro Internação Dr.Achei + Dr Achei Card'" >Mais Vendido!</p>
                          </div>
                      </div>
                  </div>
                  <hr>
                  <ul>
                      <li class="plus-icn" v-for="(beneficio, i) in plano.beneficios" :key="i" v-html="beneficio">
                      </li>
                  </ul>
                  <span class="alert">
                      <p v-for="(outroBeneficio, t) in plano.outrosBeneficios" :key="t"><b>{{outroBeneficio}}</b></p>
                  </span>
                  <a v-if="plano.linkSaibaMais" :href="plano.linkSaibaMais" class="btn btn-success btn-sm btn-block">
                      Saiba Mais
                  </a>
                  <router-link tag="a" :to="{name: 'FormSinSaude', query: {plano: plano.name}}" class="btn btn-primary btn-comprar">Adquirir</router-link>
              </div>
            </div>
        </div>
      </div>
    </section>
</template>
<script>
import * as http from 'axios'
import BannerPromocaoPlanos from '@/components/BannerPromocaoPlanos'

export default {
  components: {
    BannerPromocaoPlanos
  },

  data () {
    return {
      planos: [],
      money: {
        prefix: ''
      }
    }
  },
  async created () {
    const response = await http.get('/planos?drachei=true&publicado=true&sort=ordem')
    this.planos = response.data
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/SinSaudePlanos.vue